import { FC } from 'react';

import { FontWeightEnum, Heading, HeadingEnum } from '@argenta/react-ui';
import { clsx } from 'clsx';

import { useToggles } from '../../hooks/useToggles';
import { I18nLink } from '../I18nLink';
import { ImageWithFallback } from '../ImageWithFallback';

import { VacancyPageTemplateProps } from './VacancyPageTemplate.types';

import './VacancyPageTemplate.styles.scss';

export const VacancyPageTemplate: FC<VacancyPageTemplateProps> = ({
  title,
  underTitleContent,
  applyButton,
  contentIsForm,
  children,
  returnLinkTop,
  returnLinkBottom,
}) => {
  const {
    ops: { applicationFormImage },
  } = useToggles();

  const classNames = clsx('argnt-vacancy-page-template__title-block', {
    'argnt-vacancy-page-template__title-block--with-padding': contentIsForm,
  });

  return (
    <div className="argnt-vacancy-page-template">
      {returnLinkTop && <I18nLink {...returnLinkTop} />}
      <div className="argnt-vacancy-page-template__container">
        <ImageWithFallback
          className="argnt-vacancy-page-template__top-image"
          alt=""
          fallbackImageSource={`${process.env.PUBLIC_URL}/assets/images/application_form_top.jpg`}
          imageSource={applicationFormImage}
        />
        <div className={classNames}>
          <div className="argnt-vacancy-page-template__title-block__left_wrapper">
            {title && (
              <Heading type={HeadingEnum.H2} fontWeight={FontWeightEnum.BOLD} as="h1">
                {title}
              </Heading>
            )}
            {underTitleContent}
          </div>
          {applyButton && (
            <div className="argnt-vacancy-page-template__title-block__right_wrapper">
              {applyButton}
            </div>
          )}
        </div>
        <div
          className={clsx('argnt-vacancy-page-template__content', {
            'argnt-vacancy-page-template__content--with-padding': contentIsForm,
          })}
        >
          {children}
        </div>
      </div>
      {returnLinkBottom && <I18nLink {...returnLinkBottom} />}
    </div>
  );
};
